import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PricingCards() {
  return <section id="pricing" className="py-20 px-4" data-id="element-218">
      <div className="max-w-lg mx-auto" data-id="element-219">
        <div className="text-center mb-16" data-id="element-220">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-221">
            OBTENÉ TU MEGAPACK
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-dark-card border-2 border-gold rounded-2xl p-8 flex flex-col shadow-[0_0_40px_rgba(212,168,67,0.15)]" data-id="element-222">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-dark font-bold px-6 py-1.5 rounded-full text-sm tracking-widest flex items-center gap-2 shadow-lg" data-id="element-223">
            <span data-id="element-224">⭐</span> EL MÁS COMPLETO
          </div>

          <div className="text-center mb-8 mt-4" data-id="element-225">
            <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-226">
              📘 MEGAPACK SISTEMA SOBERANO
            </h3>
            <p className="text-gold-light font-medium" data-id="element-227">6 Tomos + 6 Bonos</p>
          </div>

          <div className="bg-dark/50 rounded-lg p-4 mb-8 border border-dark-border" data-id="element-228">
            <p className="text-sm text-gray-300 text-center" data-id="element-229">
              <span className="font-bold text-white" data-id="element-230">Ideal para:</span>{' '}
              Reprogramarte completamente con el sistema más completo de PNL
              aplicada a Argentina
            </p>
          </div>

          <div className="text-center mb-8" data-id="element-231">
            <div className="text-gray-500 line-through mb-1" data-id="element-232">
              Valor real: $69.000
            </div>
            <div className="text-sm text-gold font-bold tracking-widest mb-1" data-id="element-233">
              PRECIO HOY:
            </div>
            <div className="text-5xl font-heading font-bold text-white" data-id="element-234">
              $19.990 <span className="text-2xl text-gray-400" data-id="element-235">ARS</span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-236">
            <motion.a href="https://academiaholisticaargentina.com/cart/48928799129850:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('MegaPack Sistema Soberano', 19990)} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full py-4 text-center bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-lg rounded-lg shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] transition-all" data-id="element-237">
              → QUIERO MI MEGAPACK
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}